<template>
  <v-row class="filter-box my-0" data-id-e2e="seriesFilterSelect">
    <v-col cols="3" class="ps-0">
      {{ t('workpackagePage.splitWorkpackages.filterAssortmentSeries') }}
    </v-col>
    <v-select
      v-model="selectedSeries"
      :items="assortmentSeries"
      hide-details
      white
      multiple
      :disabled="!assortmentSeries.length"
      :placeholder="t('filterWorkpackagesOptions.noOption')"
      class="rtls-select rtls-select--white"
      data-id-e2e="seriesSelect"
      @update:model-value="updateMainFilterObject()"
    >
      <template #selection="{ item, index }">
        <span v-if="index < 1" class="selected-items">{{ item.title }} </span>
        <span v-if="index === 1" class="text-grey text-caption">
          (+{{ selectedSeries.length - 1 }}{{ t('workpackagePage.splitWorkpackages.moreSeries') }})
        </span>
      </template>
      <template #prepend-item>
        <div class="sticky">
          <div class="d-flex justify-space-around align-center pt-2">
            <v-btn class="button-link" variant="text" @click="selectAll">
              <v-icon size="16"> mdi-check </v-icon>
              <span>{{ t('actions.selectAll') }}</span>
            </v-btn>
            <v-btn class="button-link" variant="text" @click="selectNone">
              <v-icon size="16"> mdi-checkbox-blank-outline </v-icon>
              <span>{{ t('actions.selectNone') }}</span>
            </v-btn>
          </div>
          <v-divider class="mt-2" />
        </div>
      </template>
    </v-select>
  </v-row>
</template>

<script>
import filterTypeEnum from '@enums/wp-filter-types';
import { map, compact, uniq, isEmpty, get } from 'lodash';

// composables
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  props: {
    wpFurniture: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { t } = useInternationalization();
    return { t };
  },

  data: () => ({ selectedSeries: [] }),

  computed: {
    assortmentSeries() {
      if (isEmpty(this.wpFurniture.furniture)) {
        return [];
      }

      return uniq(
        compact(
          map(this.wpFurniture.furniture, f =>
            get(f, 'clientProvidedMetadata.furnitureAssortmentSeries', null)
          )
        )
      ).sort();
    },
  },

  watch: {
    // When the assortmentSeries array gets initialised, we should select all by default.
    wpFurniture() {
      this.selectAll();
      this.$emit('updateMainFilterObject', {
        type: filterTypeEnum.series,
        update: this.selectedSeries,
        isInit: true,
      });
    },
  },

  methods: {
    async updateMainFilterObject() {
      this.$emit('updateMainFilterObject', {
        type: filterTypeEnum.series,
        update: this.selectedSeries,
      });
    },

    selectAll() {
      this.selectedSeries = [...this.assortmentSeries];
    },

    selectNone() {
      this.selectedSeries = [];
      this.updateMainFilterObject();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

:deep(.v-select__selections) {
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: none;
}
:deep(.v-list) {
  position: relative;
}

.filter-box {
  align-items: center;

  span {
    padding-left: 0;
  }
}

.selected-items {
  padding-left: 5px !important;
}

.sticky {
  position: sticky;
  background-color: $canvas-header-white-background;
  top: 0;
}

.button-link {
  color: $assortment-primary-colour;
  padding: 0 !important;
  &::before,
  &::after {
    display: none !important;
  }

  span {
    text-decoration: underline;
  }
}
</style>
